<div class="modal-wrapper" *transloco="let t;" cdkTrapFocus>
    <div class="header">
        <div class="header-wrapper">
            <div class="title-wrapper">
                <h1 class="title">{{ step() === 'follow-up' ? t('modals.survey.title') : (introText() || t('modals.survey.title')) }}</h1>
            </div>
            <button class="button-undecorated" (click)="onCloseOrSkip()" [ariaLabel]="t('modals.survey.ariaLabelClose')">
                <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
            </button>
        </div>
        @if (!isMobile()) {
        <div class="subtitle-wrapper">
            <p class="subtitle">{{ t('modals.survey.subtitle') }}</p>
        </div>
        }
    </div>

    @if (step() === 'rating') {
    <div class="content-wrapper">
        @for (q of questions(); track q) {
        <cwo-rating-row [question]="q.question" [questionId]="q.id" (selected)="onAnswer(q.id, $event)" />
        }
    </div>
    } @else {
    <div class="content-wrapper follow-up-wrapper">
        @if (followUpQuestion()) {
        <label id="follow-up-feedback-label" for="follow-up-feedback-textarea" class="follow-up-subtitle">{{ followUpQuestion()!.question }}</label>
        }
        <textarea
            #followUpTextarea
            id="follow-up-feedback-textarea"
            class="follow-up-textarea"
            name="follow-up-feedback"
            [placeholder]="t('modals.survey.follow_up.placeholder')"
            [attr.aria-labelledby]="followUpQuestion() ? 'follow-up-feedback-label' : null"
            [attr.aria-label]="followUpQuestion() ? null : t('modals.survey.follow_up.placeholder')"
            maxlength="400"
            [ngModel]="additionalFeedback()"
            (ngModelChange)="onFollowUpTextChange($event)"
        ></textarea>
    </div>
    }

    @if(serverErrors && serverErrors.message){
    <div class="generic-errors">
        <span class="error"><cwo-icon class="icon"
                [name]="iconNameType.error"></cwo-icon>{{serverErrors.message}}</span>
    </div>
    }

    @if (step() === 'rating') {
        @if(allQuestionsAnswered()) {
        <button class="button-accent action-button" cwoAsyncButton [subscription]="loadingSubscription" (click)="onSubmitRatings()">
            {{ submitText() || t('modals.survey.submit') }}
        </button>
        }
    } @else {
        <button class="button-accent action-button" cwoAsyncButton [subscription]="loadingSubscription" (click)="onSubmitFollowUp()">
            {{ t('modals.survey.follow_up.submit') }}
        </button>
    }
</div>
